
enum ESquareRedirectCode {
    SIGNUP = 'SQSU',
    REAUTH = 'SQRA'
}
export default ESquareRedirectCode;